<template>
  <button
    class="ChatQuestionCard"
    :aria-busy="isLoading"
  >
    <IconTag
      iconName="Hexagon"
      label="Chat"
    />
    <UIText
      class="ChatQuestionCard__text"
      size="Medium"
      weight="Medium"
      data-testid="text"
      isMultiline
    >
      {{ formattedQuestionText }}
    </UIText>
  </button>
</template>

<script lang="ts" setup>
import IconTag from "@cosine/components/IconTag.vue";
import UIText from "@cosine/components/UIText.vue";
import { IFinancialInsightsCommonQuestion } from "@cosine/lib/api-models";
import stripMarkdown from "@cosine/lib/utils/string/stripMarkdown";
import { computed } from "vue";

const modelValue = defineModel<IFinancialInsightsCommonQuestion>({
  required: true,
});

defineProps<{
  isLoading?: boolean,
}>();

const formattedQuestionText = computed(() => {
  return stripMarkdown(modelValue.value.QuestionText);
});
</script>

<style lang="scss" scoped>
.ChatQuestionCard {
  display: grid;
  grid: min-content auto / auto;
  gap: 16px;
  padding: 16px var(--layoutMargin) 16px;

  border-radius: 12px;
  background-color: var(--colorWhite);

  text-align: left;

  cursor: pointer;

  &[aria-busy="true"] {
    background-color: var(--themeColorBackgroundOffset);
    cursor: wait;
  }
}

.ChatQuestionCard__text {
  align-self: end;
}
</style>
